import api from './axios';

export interface Publication {
    id: string;
    title: string;
    content: string;
    excerpt?: string;
    imageUrl?: string;
    tags?: string[];
    category: string;
    published: boolean;
    author?: any; // To be typed precisely with User interface if shared
    createdAt: string;
    updatedAt: string;
}

export interface CreatePublicationData {
    title: string;
    content: string;
    excerpt?: string;
    imageUrl?: string;
    tags?: string[];
    category?: string;
    published?: boolean;
}

export const getPublications = async (): Promise<Publication[]> => {
    const response = await api.get('/publications/all-publications');
    return response.data;
};

export const createPublication = async (data: CreatePublicationData): Promise<Publication> => {
    const response = await api.post('/publications/add-publication', data);
    return response.data;
};

export const updatePublication = async (id: string, data: Partial<CreatePublicationData>): Promise<Publication> => {
    const response = await api.patch(`/publications/update-publication/${id}`, data);
    return response.data;
};

export const deletePublication = async (id: string): Promise<void> => {
    await api.delete(`/publications/delete-publication/${id}`);
};

export const uploadPublicationImage = async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);

    // Set explicit multipart/form-data with boundary is automatically handled when passing FormData
    const response = await api.post('/publications/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data.url;
};
